import { useDispatch, useSelector } from "react-redux";

import { regionCodes } from "common/static/regions";

import { getRegion, getUserEmail } from "seneca-common/features/user/state";

import {
  getHelpLinkRegionCode,
  getShowNewFeatures
} from "features/regions/selectors";
import { getSellPremiumToUser } from "features/subscriptions/utils/showPremiumAds";
import { signOut } from "features/user";

export type TeacherNavbarProps = ReturnType<typeof useGetTeacherNavbarProps>;

export default function useGetTeacherNavbarProps() {
  const region = useSelector(getRegion)!;
  const locale = useSelector(getHelpLinkRegionCode);
  const sellPremiumToUser = useSelector(getSellPremiumToUser);
  const showNewFeatures = useSelector(getShowNewFeatures);
  const showInviteParents = region === regionCodes.GB;
  const email = useSelector(getUserEmail)!;
  const dispatch = useDispatch();

  const signOutOnClick = () => dispatch(signOut());

  return {
    email,
    locale,
    region,
    sellPremiumToUser,
    showNewFeatures,
    showInviteParents,
    signOutOnClick
  };
}
